export default {
	AGUARDANDO_RECEBIMENTO: {
		text: 'Aguardando Recebimento',
		value: 'AGUARDANDO_RECEBIMENTO',
	},
	RECEBIMENTO_PARCIAL: {
		text: 'Recebimento Parcial',
		value: 'RECEBIMENTO_PARCIAL',
	},
	RECEBIMENTO_FINALIZADO: {
		text: 'Recebimento Finalizado',
		value: 'RECEBIMENTO_FINALIZADO',
	},
	ESTORNO: {
		text: 'Estornado',
		value: 'ESTORNO',
	},
}
